<template>
  <div class="pager" v-if="pageMax > 1">

    <div class="pager__block">
      <router-link tag="button" :to="{ params: { page: 'page' + (pageCurrent - 1) }}" class="btn btn-outline btn-prev" :disabled="this.isBackBtnDisabled">
        <svg class="icon" width="8.5" height="18" viewBox="0 0 8.5 13.8" fill-rule="evenodd">
          <title>前</title>
          <path d="M12,8,6,14l1.41,1.41L12,10.83l4.59,4.58L18,14Z" transform="scale(1.15) translate(-8 18) rotate(-90)"></path>
        </svg>
      </router-link>
    </div>

    <div class="pager__block">
      <div class="pages">
        <router-link tag="button" :to="{ params: { page: 'page' + page }}" v-for="(page, index) in pagerArr" :key="index" class="btn btn-outline btn-pager" :class="{current: (pageCurrent === page)}">
          {{page}}
        </router-link>
      </div>

      <div class="page-counter"><b>{{pageCurrent}}</b> / {{pageMax}}</div>
    </div>

    <div class="pager__block">
      <router-link tag="button" :to="{ params: { page: 'page' + (pageCurrent + 1) }}" class="btn btn-outline btn-next" :disabled="this.isNextBtnDisabled">
        <svg class="icon" width="8.5" height="18" viewBox="0 0 8.5 13.8" fill-rule="evenodd">
          <title>後</title>
          <path d="M12,8,6,14l1.41,1.41L12,10.83l4.59,4.58L18,14Z" transform="scale(1.15) translate(16 -6) rotate(90)"></path>
        </svg>
      </router-link>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: function () {
    return {
    }
  },
  computed: {
    ...mapState('commentsData', ['pageMax', 'pageCurrent', 'pagerArr']),
    isBackBtnDisabled: function () {
      const isBtnDisabled = this.pageCurrent - 1 === 0 || this.pageCurrent === undefined
      return isBtnDisabled
    },
    isNextBtnDisabled: function () {
      const isBtnDisabled = this.pageCurrent + 1 > this.pageMax || this.pageCurrent === undefined
      return isBtnDisabled
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" src="./pageNation.scss"></style>



// WEBPACK FOOTER //
// src/components/molecules/pageNation/pageNation.vue